/*
 * @Description:
 * @Author: HG
 * @Date: 2019-08-21 13:38:08
 * @LastEditors: SYY 188842798@qq.com
 * @LastEditTime: 2024-06-24 14:42:56
 */
import urls from "./url";
import axios from "axios";
// import store from "@/store";
import { Notify, Dialog } from "vant";
import { jump, cache } from "@/utils/common";
import $config from "@/config/baseConfig";

const $get = (url, data, options = {}) => {
  const apiurl = urls[url] ? urls[url] : url;
  options.method = "get";
  return new Promise((resolve, reject) => {
    fetch(apiurl, data, options)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject && reject(error);
      });
  });
};

const $post = (url, data, options = {}) => {
  const apiurl = urls[url] ? urls[url] : url;
  options.method = "post";
  return new Promise((resolve, reject) => {
    fetch(apiurl, data, options)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject && reject(error);
      });
  });
};

const $del = (url, data, options = {}) => {
  const apiurl = urls[url] ? urls[url] : url;
  options.method = "delete";
  return new Promise((resolve, reject) => {
    fetch(apiurl, data, options)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject && reject(error);
      });
  });
};

const fetch = (url, data, options) => {
  if (!options) {
    options = {
      method: "post",
    };
  }
  options.url = url;
  if (options.method === "get") {
    options.params = data;
  } else {
    options.data = data;
  }

  var headers = {};
  headers["Content-Type"] =
    options && options.headers
      ? options.headers["Content-Type"]
      : "application/json;charset=UTF-8";
  delete options.headers;

  const user = cache.get("user");

  if (user) {
    const token = user.token;
    headers.Authorization = token;
    // 判断过期时间，获取新的token
    // const userCacheData = localStorage.getItem("opu__user");
    // if (userCacheData) {
    //   const expire = JSON.parse(userCacheData).expire;
    //   const reloadTimestamp = expire - 60 * 60 * 1000;
    //   const timestamp = new Date().getTime();

    //   if (
    //     timestamp > reloadTimestamp &&
    //     !options.reloadToken &&
    //     options.url.indexOf("GetToken") < 0
    //   ) {
    //     store.dispatch("getToken");
    //   }
    // }
  }
  // console.log($config.serverUrl);

  return new Promise((resolve, reject) => {
    const instance = axios.create({
      headers: headers,
      baseURL: $config.serverUrl,
      timeout: $config.timeOut ? $config.timeOut : 30 * 1000, // 30秒超时
    });
    instance(options)
      .then(response => {
        if (response.status === 200) {
          const Result = response.data.code;
          const ResultMessage = response.data.message;
          if (Result === 0) {
            resolve(response.data); // 成功回调
          } else if (Result === 99) {
            if (options.alertError !== false) {
              Notify(response.data.message);
            }
            reject(response);
          } else {
            // $msg("danger", response.data.Message);
            if (
              options.alertError !== false &&
              response.data.message !== "EXIST" &&
              response.data.message !== "EXISTCHARGED"
            ) {
              // Notify("Code" + Result + ResultMessage);
              Notify(ResultMessage);
            }
            reject(response);
          }
        } else {
          if (options.alertError !== false) {
            Notify("status:" + response.status + "请求出错，请稍后尝试！");
          }
          reject(response);
        }
      })
      .catch(error => {
        // $loading.close();

        if (error.response && error.response.status === 401) {
          cache.remove("user");
          if ($config.isAlertLoginMsg) {
            Dialog.confirm({
              title: error.response.status,
              message: "身份验证失败，请重新登录",
              confirmButtonText: "重新登录",
            })
              .then(() => {
                // on confirm
                jump("login");
              })
              .catch(() => {
                // on cancel
              });
          } else {
            jump("login");
          }
        } else if (error.response && error.response.status === 403) {
          // $alert("您没有权限");
        } else if (options.alertError !== false) {
          Notify(error.response.status + "请求出错，请稍后尝试！");
        }
        reject(error);
      });
  });
};

export default {
  $get,
  $post,
  $del,
};
